import { z } from 'zod'
import {
  treeMarkColorSchema,
  treeMarkShapeSchema,
} from '../enums/tree-mark.enum.js'

/**
 * Creating or renaming a species.
 *
 * The mark is required on create rather than defaulted. A defaulted shape and
 * color would put two species on one map wearing the same mark, which is the
 * one thing a legend cannot survive — and picking it is a one-tap decision at
 * the moment somebody is already thinking about the species.
 */
export const createTreeSpeciesInputSchema = z
  .object({
    name: z.string().trim().min(1, 'A species needs a name').max(80),
    shape: treeMarkShapeSchema,
    color: treeMarkColorSchema,
    sortOrder: z.number().int().min(0).max(9999).optional(),
  })
  .strict()

export type CreateTreeSpeciesInput = z.infer<
  typeof createTreeSpeciesInputSchema
>

/**
 * Every field optional; absent means "leave it alone".
 *
 * No `.default()` anywhere, deliberately. A default survives `.partial()` and
 * arrives as a value the caller never sent — which on this record would mean
 * renaming a species silently re-coloring it. See the note in `tree.input.ts`,
 * where exactly that shipped once.
 */
export const updateTreeSpeciesInputSchema = createTreeSpeciesInputSchema
  .partial()
  .strict()

export type UpdateTreeSpeciesInput = z.infer<
  typeof updateTreeSpeciesInputSchema
>
